import { areaList } from '@/components/Auth/Street/config'
import { envApi } from '@/apis'
import * as dayjs from 'dayjs'

const getTimePicker = async (source = 'sun') => {
    const { body: {
        [`${source}ScoreDeadLine`]: endTime,
        [`${source}ScoreStartTime`]: startTime
    } } = await envApi.envsGet({
        params: {
            key: `${source}ScoreDeadLine,${source}ScoreStartTime`
        }
    })
    const startMonth = dayjs(startTime).startOf('M')
    const currentMonth = dayjs().startOf('M')
    const endMonth = dayjs(endTime).isBefore(currentMonth) ? dayjs(endTime).startOf('M') : currentMonth
    let res = []
    var m = startMonth
    while(dayjs(m).isBefore(endMonth) || dayjs(m).isSame(endMonth)) {

        if (source == 'sun') {
            res.push({
                text: dayjs(m).format('YYYY年MM月'),
                value: `${dayjs(m).month() + 1}`
            })
            
        } else {
            // dayjs(startTime).isBefore(dayjs(m).add(15, 'day')) && res.push({
            //     text: dayjs(m).format('YYYY年MM月') + '-上',
            //     value: `${dayjs(m).month() + 1}_1`
            // })
            // dayjs().isAfter(dayjs(m).add(15, 'day')) && res.push({
            //     text: dayjs(m).format('YYYY年MM月') + '-下',
            //     value: `${dayjs(m).month() + 1}_2`
            // })

            res.push({
                text: dayjs(m).format('YYYY年MM月'),
                value: `${dayjs(m).month() + 1}`
            })
        }
        m = dayjs(m).add(1, 'M')
    }
    return res
}

export const tabs = {
    sun: [{
        label: '总积分榜',
        rankType: 'total'
    }, async () => ({
            label: '月积分榜',
            timePicker: await getTimePicker(),
            rankType: 'monthly',
            showTitle: true
    }), (val) => ({
        label: `${areaList.province_list[val.street_code]}排行榜`,
        rankType: 'street_total',
    }), {
        label: '挑战榜',
        rankType: 'challenge_total'
    }, (val) => ({
        label: '街乡人数榜',
        rankType: 'street_people',
        columnsLabel: ['排名', '街乡', '人数'],
        numLabel: `${areaList.province_list[val.street_code]}排名`,
        scoreLabel: '人数'
    }), (val) => ({
        label: '街乡分数榜',
        rankType: 'street_score',
        columnsLabel: ['排名', '街乡', '总分数'],
        numLabel: `${areaList.province_list[val.street_code]}排名`,
        scoreLabel: '分数'
    }), () => ({
        label: '学校分数榜',
        rankType: 'school_score',
        columnsLabel: ['排名', '学校', '总分数'],
        numLabel: "我的学校排名",
        scoreLabel: '分数',
        limit: 100
    })],
    agriculture: [{
        rankType: 'agri_total',
        label: '总积分榜'
    }, async () => ({
        rankType: 'agri_monthly',
        label: '月积分榜',
        timePicker: await getTimePicker('agri')
    })]
}